module.exports = __webpack_public_path__ + "static/bg-light-desc-8a6db14ff6d45e4eeec15e15f0f002a4.png";